module.exports = __webpack_public_path__ + "img/线路.38252567.png";